module.exports = __webpack_public_path__ + "media/images/logos/workable-2dca9394235ed7abe39c912c5e1e7b3c.png";